/**
 * Get Aggregate Query
 * 
 * Query for retrieving aggregate information for read operations.
 */

import { IQuery, BaseQuery } from '@swoft/core';

export interface AggregateDto {
  aggregateId: string;
  boundedContextId: string;
  name: string;
  description?: string;
  responsibility: string;
  rootEntity: any;
  childEntities: any[];
  valueObjects: any[];
  businessInvariantIds: string[];
  domainEventIds: string[];
  ubiquitousLanguageTerms: string[];
  complexityScore: number;
  cohesionScore: number;
  createdAt: Date;
  updatedAt: Date;
}

export class GetAggregateQuery extends BaseQuery<AggregateDto> {
  constructor(
    public readonly aggregateId: string,
    authSessionId: string,
    initiatedByPersonId: string,
    correlationId?: string
  ) {
    super(authSessionId, initiatedByPersonId, correlationId);
  }
}

export class ListAggregatesQuery extends BaseQuery<AggregateDto[]> {
  constructor(
    public readonly boundedContextId?: string,
    public readonly domainId?: string,
    public readonly includeComplexityAnalysis: boolean = false,
    authSessionId: string = 'system',
    initiatedByPersonId: string = 'system',
    correlationId?: string
  ) {
    super(authSessionId, initiatedByPersonId, correlationId);
  }
}